"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6758],{

/***/ 6758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/PageHeader.js
var PageHeader = __webpack_require__(9792);
;// CONCATENATED MODULE: ./src/magnolia/components/PageHeader/PageHeader.tsx


function PageHeader_PageHeader(param) {
    var heading = param.heading, leadText = param.leadText, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* PageHeader */.m, {
            heading: heading,
            leadText: leadText,
            backgroundColor: backgroundColor
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/PageHeader/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7720);



const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      "data-testid": "page-header",
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.pageHeader, c, l),
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, g) : null
  );
}

//# sourceMappingURL=PageHeader.js.map


/***/ })

}]);